import CustomTooltip from '../../../common/CustomTooltip/CustomTooltip';
import { CreatorChallenge } from '../../../../types/challenges';
import { formatChallengeAmount, getChallengeRewardProductNames } from '../../../../utils/challenge-utils';
import styles from './allChallenges.module.css';

type ChallengeRewardValueProps = {
  challenge: CreatorChallenge;
  defaultCurrency: string;
  showType?: boolean;
};

export default function ChallengeRewardValue({ challenge, defaultCurrency, showType }: ChallengeRewardValueProps) {
  if (challenge.reward.type === 'flat_fee') {
    const amount = formatChallengeAmount(challenge.reward.amountCents, defaultCurrency);
    const label = showType ? `Bonus · ${amount}` : amount;
    return <span className={showType ? undefined : styles.valueName}>{label}</span>;
  }

  const names = getChallengeRewardProductNames(challenge);
  const firstName = names[0] || '-';
  const extraCount = names.length - 1;
  const prefix = showType ? 'Free product · ' : '';
  const more = extraCount >= 1 && (
    <CustomTooltip
      title={names.join('\n')}
      multiline
      position="bottom"
      withinPortal
      zIndex={1100}
      style={{ whiteSpace: 'pre-line' }}
    >
      <span className={showType ? styles.cardMore : styles.moreCount}>+{extraCount} more</span>
    </CustomTooltip>
  );

  if (showType) {
    return (
      <span>
        {prefix}
        {firstName}
        {more ? <> {more}</> : null}
      </span>
    );
  }

  return (
    <span className={styles.valueInline}>
      <span className={styles.valueName} title={firstName}>
        {firstName}
      </span>
      {more}
    </span>
  );
}
